<template>
	<!-- <div> -->
	<v-card elevation="0">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('edit') }} {{ $t('consumable') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 122px)">
			<v-row dense v-if="editingConsumable">
				<v-col cols="12">
					<v-select
						:items="itemsConsumable"
						item-text="name"
						item-value="id"
						dense
						hide-details
						outlined
						:label="$t('models')"
						v-model="editingConsumable.consumableModelId"
						:menu-props="{ offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-select
						class="width-text-field2"
						hide-details
						dense
						v-model="editingConsumable.organizationId"
						:items="medicalInstitutions"
						item-value="id"
						item-text="institutionName"
						:label="$t('medicalInstitution')"
						outlined
						:menu-props="{ offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-select
						class="width-text-field2"
						hide-details
						dense
						:disabled="!editingConsumable.organizationId"
						v-model="editingConsumable.locationId"
						:items="hospitals.filter((hospital) => hospital.medicalInstitutionId === editingConsumable.organizationId)"
						item-value="id"
						item-text="hospitalName"
						:label="$t('hospital')"
						outlined
						:menu-props="{ offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-text-field dense hide-details outlined :label="$t('lot-number')" v-model="editingConsumable.lotNumber" />
				</v-col>
				<v-col cols="12">
					<v-menu v-model="menuExpiration" :close-on-content-click="false" offset-y min-width="auto">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formattedExpirationDate"
								:label="$t('expiration-date')"
								readonly
								single-line
								hide-details
								prepend-inner-icon="mdi-calendar"
								dense
								outlined
								v-bind="attrs"
								v-on="on" />
						</template>
						<v-date-picker
							v-model="editingConsumable.expirationDate"
							color="primary"
							scrollable
							@change="menuExpiration = false" />
					</v-menu>
				</v-col>
				<v-col cols="6">
					<v-text-field
						dense
						hide-details
						outlined
						type="number"
						:label="$t('quantity-total')"
						v-model="editingConsumable.quantityTotal" />
				</v-col>
				<v-col cols="6">
					<v-text-field
						dense
						hide-details
						outlined
						type="number"
						:label="$t('quantity-available')"
						v-model="editingConsumable.quantityAvailable" />
				</v-col>
				<v-col cols="6">
					<v-text-field
						hide-details
						dense
						outlined
						type="number"
						:label="$t('cost-per-unit')"
						v-model="editingConsumable.costPerUnit" />
				</v-col>
				<v-col cols="6">
					<v-text-field dense hide-details outlined :label="$t('currency')" v-model="editingConsumable.currency" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('supplier-name')"
						v-model="editingConsumable.supplierName" />
				</v-col>
				<v-col cols="6">
					<v-text-field
						dense
						hide-details
						outlined
						type="number"
						:label="$t('sell-price')"
						v-model="editingConsumable.sellPrice" />
				</v-col>
				<v-col cols="6">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('sell-currency')"
						v-model="editingConsumable.sellCurrency" />
				</v-col>
				<v-col cols="6">
					<v-text-field
						dense
						hide-details
						outlined
						type="number"
						:label="$t('sell-price-per-unit')"
						v-model="editingConsumable.sellPricePerUnit" />
				</v-col>
				<v-col cols="6">
					<v-text-field
						dense
						hide-details
						outlined
						type="number"
						:label="$t('sell-quantity')"
						v-model="editingConsumable.sellQuantity" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('tracking-number')"
						v-model="editingConsumable.trackingNumber" />
				</v-col>
				<v-col cols="6">
					<v-text-field
						dense
						hide-details
						outlined
						type="number"
						:label="$t('shipment-cost')"
						v-model="editingConsumable.shipmentCost" />
				</v-col>
				<v-col cols="6">
					<v-text-field
						dense
						hide-details
						outlined
						:label="$t('shipment-currency')"
						v-model="editingConsumable.shipmentCurrency" />
				</v-col>
				<v-col cols="12">
					<v-menu v-model="menuShipmentDate" :close-on-content-click="false" offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formattedShipmentDate"
								:label="$t('shipment-date')"
								readonly
								dense
								outlined
								hide-details
								prepend-inner-icon="mdi-calendar"
								v-bind="attrs"
								v-on="on" />
						</template>
						<v-date-picker
							v-model="editingConsumable.shipmentDate"
							color="primary"
							scrollable
							@change="menuShipmentDate = false" />
					</v-menu>
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense>
				<v-col cols="6" order="1">
					<v-btn elevation="0" class="cancel-button-style capitalize-text" @click="closeDrawer">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6" order="2">
					<v-btn block color="primary" :disabled="isSaveButtonDisabled" @click="editExistingConsumable">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formatTimestamp } from '../../utils/utilities';

export default {
	name: 'InventoryConsumableAssignEdit.vue',
	data () {
		return {
			loading: false,
			itemModel: {
				consumableModelId: 0,
				lotNumber: '',
				expirationDate: '',
				quantityTotal: 0,
				quantityAvailable: 0,
				costPerUnit: 0,
				currency: '',
				supplierName: '',
				sellPrice: 0,
				sellPricePerUnit: 0,
				sellQuantity: 0,
				sellCurrency: '',
				trackingNumber: '',
				shipmentCost: 0,
				shipmentCurrency: '',
				shipmentDate: {
					dayOfWeek: 0,
				},
				status: '',
			},
			inventoryConsumableCategoryOptions: [],
			itemsConsumable: [],
			menu1: false,
			selectedDateForBilling: '',
			editingConsumable: {
				consumableModelId: 0,
				lotNumber: '',
				expirationDate: '',
				quantityTotal: 0,
				quantityAvailable: 0,
				costPerUnit: 0,
				currency: '',
				supplierName: '',
				sellPrice: 0,
				sellPricePerUnit: 0,
				sellQuantity: 0,
				sellCurrency: '',
				trackingNumber: '',
				shipmentCost: 0,
				shipmentCurrency: '',
				shipmentDate: {
					dayOfWeek: 0,
				},
				status: '',
			},
			statuses: [],
			menuExpiration: false,
			menuShipmentDate: false,
			medicalInstitutions: [],
		};
	},
	methods: {
		...mapActions({
			addConsumable: 'inventoryConsumables/addConsumable',
			getConsumableCatalogs: 'inventoryConsumableCatalogs/getConsumableCatalogs',
			getInventoryConsumableStatuses: 'inventoryConsumables/getInventoryConsumableStatuses',
			editConsumable: 'inventoryConsumables/editConsumable',
			getHospitals: 'hospitals/getHospitals',
		}),
		formatTimestamp,
		async getConsumableItems () {
			const resultGet = await this.getConsumableCatalogs();
			this.itemsConsumable = resultGet;
		},
		closeDrawer () {
			this.editingConsumable = this.itemModel;
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
		},
		async editExistingConsumable () {
			const resultEdit = await this.editConsumable(this.editingConsumable);
			if (resultEdit) {
				this.closeDrawer();
			}
		},
		async fillFields () {
			this.getConsumableItems();
			this.editingConsumable = { ...this.selectedConsumable };
			const responseStatus = await this.getInventoryConsumableStatuses();
			if (responseStatus.resFlag) {
				this.statuses = responseStatus.data;
			}
			this.medicalInstitutions = this.allMedicalInstitutions.filter((m) => m.institutionName !== 'All');
		},
	},
	computed: {
		...mapState({
			allMedicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
			updateDrawer: (state) => state.updateDrawer,
			hospitals: (state) => state.hospitals.hospitals,
			selectedConsumable: (state) => state.inventoryConsumables.selectedConsumable,
		}),
		formattedExpirationDate () {
			return this.editingConsumable.expirationDate ? this.formatTimestamp(this.editingConsumable.expirationDate) : '';
		},
		formattedShipmentDate () {
			return this.editingConsumable.shipmentDate ? this.formatTimestamp(this.editingConsumable.shipmentDate) : '';
		},
		isSaveButtonDisabled () {
			const c = this.editingConsumable;
			if (!c) return true;
			if (!c.consumableModelId) return true;
			if (!c.lotNumber || c.lotNumber.trim() === '') return true;
			if (!c.expirationDate) return true;
			if (c.quantityTotal === null || c.quantityTotal === undefined || c.quantityTotal.length === 0) return true;
			if (c.quantityAvailable === null || c.quantityAvailable === undefined || c.quantityAvailable.length === 0) {
				return true;
			}
			if (!c.currency) return true;
			if (c.costPerUnit === null || c.costPerUnit === undefined || c.costPerUnit.length === 0) return true;
			if (!c.supplierName || c.supplierName.trim() === '') return true;
			if (c.sellPrice === null || c.sellPrice === undefined || c.sellPrice.length === 0) return true;
			if (c.sellPricePerUnit === null || c.sellPricePerUnit === undefined || c.sellPricePerUnit.length === 0) {
				return true;
			}
			if (c.sellQuantity === null || c.sellQuantity === undefined || c.sellQuantity.length === 0) return true;
			if (!c.sellCurrency) return true;
			if (!c.trackingNumber || c.trackingNumber.trim() === '') return true;
			if (c.shipmentCost === null || c.shipmentCost === undefined || c.shipmentCost.length === 0) return true;
			if (!c.shipmentCurrency) return true;
			if (!c.shipmentDate) return true;
			return false;
		},
	},
	async mounted () {
		this.fillFields();
		await this.getHospitals();
	},
	watch: {
		selectedConsumable: {
			immediate: true,
			deep: true,
			async handler (value) {
				this.editingConsumable = { ...value };
			},
		},
		updateDrawer: {
			immediate: true,
			deep: true,
			async handler (value) {
				this.fillFields();
			},
		},
	},
};
</script>
